import { useSelector } from 'react-redux';
import { dataSelector } from '@nextiva/global-store';

import { useQuery } from '@tanstack/react-query';
import { getVertical } from 'services';

export const useGetVertical = () => {
  const globalStoreData = useSelector(dataSelector);
  const corpAcctNbr = globalStoreData.user?.profileDTO?.corpAcctNbr;
  const enabled = !!corpAcctNbr;

  return useQuery(['getVertical'], {
    queryFn: () => getVertical(corpAcctNbr),
    enabled,
    select: (data) => {
      const unordered = data.verticalMap;
      const ordered = Object.keys(unordered)
        .sort()
        .reduce((obj, key) => {
          obj[key] = unordered[key];
          return obj;
        }, {});
      return ordered;
    },
  });
};
